const t = (e) => e.value, l = (e) => (e == null ? void 0 : e.label) ?? (e == null ? void 0 : e.value) ?? "", c = (e) => e.map((r) => l(r)).join(", ");
export {
  t as getSelectOptionValue,
  l as selectOptionToString,
  c as selectOptionsToString
};
